import { Schemas } from '@api-client/generated/types';
import { ACCESS_RIGHTS } from '@constants';
import { downloadCsv, fullName, roleLabel, toCsv } from '@utils';

type Membership = Schemas.AdminMembershipRecordDto;

const HEADERS = [
  'Employee',
  'Email',
  'Role',
  'Company',
  ...ACCESS_RIGHTS.map((right) => right.label),
];

const toRow = (membership: Membership): Array<string | boolean> => [
  fullName(membership),
  membership.email,
  roleLabel(membership.adminRole),
  membership.companyName,
  ...ACCESS_RIGHTS.map((right) =>
    membership.accessRights[right.key] ? 'Yes' : 'No'
  ),
];

/**
 * Export the full filtered membership set as one row per access grant. The
 * caller passes the already-filtered set (all of it — never a single page), so
 * the export mirrors exactly what the map shows.
 */
export const exportAccessMapCsv = (memberships: Membership[]): void => {
  const csv = toCsv(HEADERS, memberships.map(toRow));
  downloadCsv('access-map.csv', csv);
};
